import React from 'react'

export default function InfoItem(props) {
  return (
    <div className="live-info-item">
      <span className="live-info__label">{props.label}</span>
      <span className="live-info__value">{props.value}</span>
    </div>
  )
}
